import { useState } from 'react';
import { useForm } from 'react-hook-form';

// @utility
import validateInput from "@utility/app/validateInput";

// Component
import Grid from '@mui/material/Grid';

// Icon
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function LoginApp(props) {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();
    const [password, setPassword] = useState({
        password: "",
        showPassword: false
    });

    // แสดงหรือซ่อนรหัสผ่าน
    const handleClickShowPassword = () => {
        setPassword(prev => ({
            ...prev,
            showPassword: !prev.showPassword
        }));
    };

    const renderErrorUsername = () => {
        if (!errors.username) return null;

        return (
            <div className="validateError">
                {errors.username.message || "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง"}
            </div>
        );
    };

    const renderErrorPassword = () => {
        if (!errors.password) return null;

        return (
            <div className="validateError">
                {errors.password.message || "กรุณากรอกรหัสผ่านให้ถูกต้อง"}
            </div>
        );
    };

    return (
        !props.process ?
            <>
                <form onSubmit={handleSubmit(props.authenSubmit)}>
                    <div className="inputPaddingTop">
                        <br />
                        <div className="inputTextLabel">
                            เบอร์โทรศัพท์
                        </div>
                        <Grid container alignItems="center" className="inputStyles center">
                            <Grid item xs={2}>
                                <PhoneIcon className="iconSize" />
                            </Grid>
                            <Grid item xs={10}>
                                <input
                                    type="tel"
                                    inputMode="numeric"
                                    className="inputStyles inputStylesBorderNone" 
                                    placeholder="เบอร์โทรศัพท์"
                                    maxLength={10}
                                    {...register("username", {
                                        required: "กรุณากรอกเบอร์โทรศัพท์",
                                        minLength: {
                                            value: 4,
                                            message: "กรุณากรอกให้ครบ 4 หลัก"
                                        },
                                        maxLength: {
                                            value: 10,
                                            message: "กรุณากรอกไม่เกิน 10 หลัก"
                                        },
                                        pattern: {
                                            value: /^[0-9]+$/,
                                            message: "เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น (0–9)"
                                        }
                                    })}
                                    onKeyDown={(event) => validateInput(event, "number")}
                                    onPaste={(event) => validateInput(event, "number")}
                                />
                            </Grid>
                        </Grid>
                        {
                            renderErrorUsername()
                        }
                    </div>
                    <div className="inputPaddingTop">
                        <div className="inputTextLabel">
                            รหัสผ่าน
                        </div>
                        <Grid container alignItems="center" className="inputStyles center">
                            <Grid item xs={2}>
                                <LockIcon className="iconSize" />
                            </Grid>
                            <Grid item xs={8}>
                                <input
                                    type={password.showPassword ? "text" : "password"}
                                    className="inputStyles inputStylesBorderNone" 
                                    placeholder="รหัสผ่าน"
                                    maxLength={20}
                                    {...register("password", {
                                        required: "กรุณากรอกรหัสผ่าน",
                                        minLength: {
                                            value: 4,
                                            message: "กรุณาระบุรหัสผ่านอย่างน้อย 4 ตัวอักษร"
                                        },
                                        maxLength: {
                                            value: 20,
                                            message: "รหัสผ่านต้องไม่เกิน 20 ตัวอักษร"
                                        },
                                        pattern: {
                                            value: /^[A-Za-z0-9]+$/i,
                                            message:
                                                "รหัสผ่านต้องเป็นตัวอักษรภาษาอังกฤษหรือตัวเลขเท่านั้น (A–Z, a–z, 0–9)"
                                        }
                                    })}
                                    onKeyDown={(event) =>
                                        validateInput(event, "textNumber")
                                    }
                                    onPaste={(event) =>
                                        validateInput(event, "textNumber")
                                    }
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <div
                                    onClick={handleClickShowPassword}
                                >
                                    {password.showPassword ? <Visibility className="iconSize" /> : <VisibilityOff className="iconSize" />}
                                </div>
                            </Grid>
                        </Grid>
                        {
                            renderErrorPassword()
                        }
                    </div>
                    <div className="inputPaddingTop right">
                        <div className="inputTextLabel" style={{ paddingBottom: "0px", borderBottom: "1px solid white", display: "inline-block", paddingLeft: "0px", color: "white", cursor: "pointer" }} onClick={() => { props.switchChanel("remember") }}>
                            ลืมรหัสผ่านใช่หรือไม่ ?
                        </div>
                    </div>


                    <div className="center">
                        <div className="inputPaddingTop" style={{ paddingTop: "10px" }}>
                            <button id="login_button" type="submit" className="btn btnConfirm btnHover btnWidthLarge btnRadius textBoldHight">
                                เข้าสู่ระบบ
                            </button>
                        </div>
                    </div>
                </form>
                <div className="boxMarginTop center">
                    <div className="inputNotRegister">
                        ยังไม่ได้เป็นสมาชิก?
                    </div>

                    <div className="boxMarginTop">
                        <button className="btn btnLogin btnHover btnWidthLarge btnRadius textBoldHight" onClick={() => { props.switchChanel("register") }}>
                            สมัครสมาชิก
                        </button>
                    </div>
                </div>
            </>
            :
            null
    );
}